import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parse, differenceInYears } from 'date-fns';

export function DOBValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let err: any = {};

    const dateOfBirth = control.value;
    const age = calculateAge(dateOfBirth);

    const isValid18OrOver = age >= 18;
    const isValidUnder100 = age < 100;

    if (!isValid18OrOver) {
      err = { max: true };
    } else if (!isValidUnder100) {
      err = { min: true };
    }

    return err;
  };
}

export function calculateAge(dateOfBirth: string): number {
  const date = parse(dateOfBirth, 'yyyy-MM-dd', new Date());
  const age = differenceInYears(new Date(), date);
  return age;
}
